import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-clip-number',
  templateUrl: './clip-number.component.html',
  styleUrls: ['./clip-number.component.scss']
})
export class ClipNumberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
